import ContactForm from "../components/contactForm";

const ContactPage = () => {
  return <ContactForm />;
};

export default ContactPage;